<template>
  <section style="width: 50%; margin: 5% auto">
    <el-col>
      <el-form @submit.native.prevent :model="filters">
        <el-form-item>
          <el-input
            v-model="filters.PhoneNumber"
            placeholder="手机号码"
            clearable
            @keyup.enter.native="handleQuery"
            ref="phoneNumberRef"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <el-card class="box-card">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="签到状态">
          <img
            style="height: 20px"
            v-if="form.EAR_Sign == 1"
            src="../../assets/ok.svg"
            :alt="form.EAR_SignStr"
          />
          <img
            style="height: 20px"
            v-else
            src="../../assets/error.svg"
            :alt="form.EAR_SignStr"
          />
        </el-form-item>
        <el-form-item label="签到时间" prop="EAR_signTime">
          <el-input v-model="form.EAR_signTime" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="EAR_Name">
          <el-input v-model="form.EAR_Name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="PhoneNumber">
          <el-input v-model="form.PhoneNumber" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="票号" prop="EAR_OrderNumber">
          <el-input v-model="form.EAR_OrderNumber" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="公司名称" prop="EAR_Company">
          <el-input v-model="form.EAR_Company" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="EAR_Remark">
          <el-input v-model="form.EAR_Remark" :disabled="true"></el-input>
        </el-form-item>
      </el-form>
    </el-card>
  </section>
</template>

<script>
import { activityRegistrationScanSign } from '../../api/api'
import store from '@/store'
export default {
  data() {
    return {
      filters: {
        PhoneNumber: '',
        ActivityID: store.getters.getCurActivityId,
      },
      form: {
        EAR_SignStr: '',
        EAR_signTime: '',
        EAR_Name: '',
        PhoneNumber: '',
        EAR_OrderNumber: '',
        EAR_Company: '',
        EAR_Remark: '',
      },
    }
  },
  components: {
    // Toolbar
  },
  methods: {
    handleQuery() {
      if (!this.filters.ActivityID) {
        this.$message({
          message: '非正常访问',
          type: 'error',
        })
        setTimeout(() => {
          this.$router.push(`/DetpActivity/Activity`)
        }, 2000)
        return
      }
      // this.listLoading = true
      activityRegistrationScanSign(this.filters).then((res) => {
        if (res.data.success) {
          this.form = res.data.response
        } else {
          this.$refs['form'].resetFields()
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
  },
  mounted() {
    setInterval(() => {
      this.$refs.phoneNumberRef.focus()
    }, 1000)
  },
}
</script>
<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
::v-deep .el-input__inner {
  color: #020202 !important;
  background-color: #ecf5ff03 !important;
  border-color: #ae98a42b !important;
}
</style>
